import { FC, useRef } from 'react';
import { SvgIcon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CallbackIcon } from 'src/assets/svg/callback-us.svg';

import { appConfig } from '../../../app/app-config';

import { ContactUsButton } from './contact-us-button';

export const RequestCallback: FC = () => {
    const { t } = useTranslation();
    const Icon = useRef(
        <SvgIcon>
            <CallbackIcon />
        </SvgIcon>
    );

    return (
        <ContactUsButton icon={Icon.current} href={appConfig.contacts.callbackForm} newTab>
            <Typography>{t('contact_us_schedule_call')}</Typography>
        </ContactUsButton>
    );
};
